import * as React from 'react';

interface Props {
  testoEmail: string
}

const Email: React.VFC<Props> = (props: Props) => {

  return (
    <div dangerouslySetInnerHTML={{ __html: props.testoEmail }} />
  );
}

export default Email;
